import React from 'react'
import {
    Form,
  Input,
  Toast,
  Space,InfiniteScroll,DotLoading,Popup,List,ActionSheet,
  Button,Swiper,Ellipsis,Image,Grid,NavBar,Tabs,Avatar,Tag,SearchBar,FloatingBubble,Footer,ImageViewer
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, MoreOutline,BellOutline,MessageFill,EditSOutline ,SmileOutline,GiftOutline} from 'antd-mobile-icons'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import '../Posts/index.css'

import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    Posts,SaveUserAction,PostCarousels,DelPostById
  } from '../../service/service';


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            posts: [],
            totalCount: 0,
            page: 0,
            pageSize: 10,
            hasMore: true,
            loading: false,
            userInfo: {},
            initialLoading: false,

            visible: false,
            tabIdx: "1",
            demoImages: [],
            carousels: [],
        };
    }

    componentDidMount() {
        var that = this;

        // const { location } = this.props;
        // const { id } = location.state || {}; // 获取 URL 参数
        // if (id) {
        //     this.setState({
        //         id: id,
        //     })
        // }

        var data = {};
        PostCarousels(data).then(res => {
            if(res.success){
                var list = [];
                res.result.items.map(item => {
                    var name = item.imgName.split('/').pop()
                    list.push(name)
                })
                that.setState({
                    carousels: list,
                })
            }

        })

        this.setState({ initialLoading: true }, () => {
          this.loadPosts();
        });

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
        
    }

    loadPosts = async () => {
        // const { location } = this.props;
        // const { id } = location.state || {}; // 获取 URL 参数

        var that = this;
        const { page, pageSize, tabIdx, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            // PlanetId: id,
            // OpenId: "",
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
            // TypeId: tabIdx === 0 ? undefined : tabIdx
        };

        try {
            Posts(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    newPosts.map(item => {
                        // item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        if (item.headImg != null) {
                            if (item.headImg.indexOf("https://") > -1) {
                                var urls = item.headImg.split("https://").filter(Boolean);
                                item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                            }
                        }
                        var list = [];
                        var listQNY = [];
                        item.imgs.map(item1 => {
                            const pathSegments = item1.split('/');
                            var fileName = pathSegments.filter(segment => segment).pop();
                            var qnyUrl = environment.QNYImgUrl + fileName + environment.QNYImgUrlYS;
                            // listQNY.push(qnyUrl)

                            list.push(environment.apiEndpoint + item1)
                            listQNY.push(environment.apiEndpoint + item1)
                            // list.push(environment.QNYImgUrl + fileName)
                        })
                        item.imgs = list;
                        item.imgQNYs = listQNY;
                        const creationTime = new Date(item.creationTime); 
                        const now = new Date();
                        const timeDiff = now - creationTime; // 时间差（毫秒）
                        item.creationTime = that.formatTimeDifference(timeDiff);

                        var cUserActionDto = item.userActionDto;
                        item.cangCount = item.userActionDto.filter(action => action.type === 3).length;
                        item.zanCount = item.userActionDto
                            .filter(action => action.type === 2 && action.userActionId == null).length;
                        item.yanCount = item.userActionDto
                            .filter(action => action.type === 1 && action.userActionId == null).length;
                        item.cUserActionDto = cUserActionDto.filter(action => action.type === 1);
                        item.yanList = cUserActionDto.filter(action => action.type === 2);
                        item.cangList = cUserActionDto.filter(action => action.type === 3);
                    })
                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;

                    that.setState({
                        posts: [...this.state.posts, ...newPosts],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        loading: false
                    });
                }
            })
        } catch (error) {
            console.error('加载留言失败:', error);
            this.setState({
                initialLoading: false, loading: false
            });
        }
    }

    formatTimeDifference(diffInMs) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - diffInMs).toLocaleDateString("zh-CN");
        }
    }


    submitForm = (data) => {
        var that = this;
        SaveUserAction(data).then(res => {
            if (res.success) {
                const updatedPosts = that.state.posts.map(post => {
                    if (post.id === data.TableId) {
                        switch (data.Type) {
                            case 3:
                                post.cangList.push({
                                    creatorUserId: that.state.userInfo.id,
                                    type: 3,
                                })
                                post.cangCount = post.cangList.length;
                                break;
                            case 2:
                                post.yanList.push({
                                    creatorUserId: that.state.userInfo.id,
                                    type: 2,
                                })
                                post.zanCount = post.yanList.length;
                                break;
                                break;
                            default:
                                break;
                        }
                    }
                    return post;
                });

                that.setState({
                    posts: updatedPosts,
                });
            }
        })
    }
    


    render() {

        const items = this.state.carousels.map((item, index) => (
            <Swiper.Item key={index}>
                <div style={{ height: "140px" }}>
                    <Image src={"https://api.weibinyi.com/NNFiles/Img/" + item} width={"100%"} height={"140px"} fit='cover' />
                    {/* <Image src={environment.QNYImgUrl + item + environment.QNYImgUrlYS} width={"100%"} height={"140px"} fit='cover' /> */}
                </div>
            </Swiper.Item>
        ))

        return (
            <div className="posts" style={{ height: "100%", width: "100%", overflow: "auto", backgroundColor: "#f4f4f4" }}>
                {/* <NavBar  back='' backArrow={false} style={{'border-bottom':'solid 1px #e4e4e4'}}>
                    念念
                </NavBar> */}

                <Tabs defaultActiveKey='1' padding='0' style={{
                    borderTop: "1px solid #ececec", position: "sticky",
                    top: "0px", zIndex: "100", backgroundColor: "#fff"
                }} onChange={(key)=>{
                    if (key == "3") {
                        this.props.navigate('/driftingDown', { replace: true, state: { from: 'home' } }); // 传递状态
                    } else {
                        this.setState({
                            tabIdx: key
                        })
                    }
                }}>
                    <Tabs.Tab title='念念' key='1' />
                    {/* <Tabs.Tab title='问答' key='2' /> */}
                    <Tabs.Tab title='许愿' key='3' />
                </Tabs>

                {
                    this.state.tabIdx == "1" ?
                        <div style={{ padding: "8px 5px 3px" }}>
                            <Swiper
                                autoplay loop
                                autoplayInterval={3000}
                                indicatorProps={{
                                    color: 'white',
                                }}
                                defaultIndex={0}
                                style={{
                                    '--border-radius': '12px',
                                }}
                            >
                                {items}
                            </Swiper>
                        </div> : null
                }
                

                <ImageViewer.Multi
                    images={this.state.demoImages}
                    visible={this.state.visible}
                    defaultIndex={0}
                    onClose={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                />

                <div>

                    {
                        this.state.posts.map(item => {
                            return (
                                <div style={{
                                    backgroundColor: "#fff", marginTop: "10px", borderRadius: "8px"
                                }}>
                                    <div style={{ paddingTop: "7px" }}></div>

                                    <Grid columns={5} gap={8}>
                                        <Grid.Item span={1}>
                                            <div style={{ margin: "12px 0px 6px 18px" }}>
                                                <Avatar
                                                    src={item.headImg}
                                                    style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }}
                                                />
                                            </div>
                                        </Grid.Item>
                                        <Grid.Item span={3}>
                                            <div style={{ height: "100%", paddingTop: "5%", marginLeft: "3%" }}>
                                                <div style={{ fontSize: "16px", fontWeight: "600" }}>{item.creatorUserName}</div>
                                                <div>{item.creationTime}</div>
                                            </div>
                                        </Grid.Item>
                                        <Grid.Item span={1}>
                                            <div style={{
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                paddingRight: "25px"
                                            }}>
                                                <MoreOutline
                                                    fontSize={20}
                                                    onClick={() => {
                                                        const handler = ActionSheet.show({
                                                            actions: [
                                                                ...(item.creatorUserId != this.state.userInfo.id
                                                                    ? [{ text: '举报', key: 'report' }]
                                                                    : []),
                                                                ...(item.creatorUserId === this.state.userInfo.id
                                                                    ? [{ text: '编辑', key: 'edit' }]
                                                                    : []),
                                                                ...(item.creatorUserId === this.state.userInfo.id
                                                                    ? [{ text: '删除', key: 'delete', danger: true }]
                                                                    : [])
                                                            ],
                                                            cancelText: '取消',
                                                            onAction: (action) => {
                                                                var that = this;
                                                                var id = item.id;

                                                                switch (action.key) {
                                                                    case 'report':
                                                                        Toast.show({ content: '暂未开放，敬请期待！' });
                                                                        handler.close();
                                                                        break;
                                                                    case 'edit':
                                                                        console.log('点击了分享');
                                                                        handler.close();
                                                                        this.props.navigate('/postsAdd', {
                                                                            replace: true,
                                                                            state: { id: id }
                                                                        }); // 传递状态
                                                                        break;
                                                                    case 'delete':
                                                                        DelPostById(id).then(res => {
                                                                            if (res.success) {
                                                                                if (res.result) {
                                                                                    var posts = that.state.posts
                                                                                        .filter(x => x.id != id);
                                                                                    that.setState({
                                                                                        posts: posts,
                                                                                    })
                                                                                    Toast.show({ content: '删除成功！' });
                                                                                }
                                                                            }
                                                                            handler.close();
                                                                        })

                                                                        break;
                                                                }
                                                            }
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </Grid.Item>
                                    </Grid>
                                    <div style={{ padding: "0px 20px 8px 20px", fontSize: "15px" }}>
                                        <Ellipsis
                                            direction='end' rows={5}
                                            content={item.remark}
                                            expandText='展开'
                                            defaultExpanded={false}
                                            collapseText='收起'
                                            style={{
                                                whiteSpace: 'pre-line',
                                            }}
                                        />
                                    </div>
                                    <div style={{ padding: "0px 20px 4px 20px" }}>
                                        <Grid columns={3} gap={8}>
                                            {
                                                item.imgQNYs.map(item1 => {
                                                    return (
                                                        <Grid.Item span={1}>
                                                            <Image onClick={() => {
                                                                this.setState({
                                                                    visible: true,
                                                                    demoImages: item.imgs,
                                                                })
                                                            }}
                                                                src={item1}
                                                                width={"100%"}
                                                                height={110}
                                                                fit='cover'
                                                                style={{ borderRadius: 4 }}
                                                            />
                                                        </Grid.Item>)
                                                })
                                            }
                                        </Grid>
                                    </div>

                                    <div style={{ marginTop: "6px" }}>
                                        <Grid columns={3} gap={8}>
                                            <Grid.Item span={1}>
                                                <div style={{ fontSize: "12px", paddingLeft: "20px", fontWeight: "600" }}>
                                                    <Space wrap>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/1/1-16.png"} fit='fill' width={17} height={17} />
                                                        <span>{item.planetName}</span>
                                                    </Space>
                                                </div>
                                            </Grid.Item>
                                            <Grid.Item span={2}>
                                                <div style={{ fontSize: "15px", paddingRight: "15px", textAlign: "end", lineHeight: "16px" }}>

                                                    <Space wrap>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/1/1-17.png"}
                                                            fit='fill' width={15} height={15} onClick={() => {
                                                                var data = {
                                                                    TableId: item.id,
                                                                    Type: 3,
                                                                    TableType: "Post",
                                                                };
                                                                var model = item.cangList.filter(action =>
                                                                    action.creatorUserId === this.state.userInfo.id);
                                                                if (model.length > 0) {
                                                                    return;
                                                                }
                                                                this.submitForm(data)
                                                            }} />
                                                        <span style={{ marginRight: "15px" }} onClick={() => {
                                                            var data = {
                                                                TableId: item.id,
                                                                Type: 3,
                                                                TableType: "Post",
                                                            };
                                                            var model = item.cangList.filter(action =>
                                                                action.creatorUserId === this.state.userInfo.id);
                                                            if (model.length > 0) {
                                                                return;
                                                            }
                                                            this.submitForm(data)
                                                        }}>{item.cangCount}</span>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                            fit='fill' width={15} height={15} onClick={() => {
                                                                this.props.navigate('/myPostsInfo',
                                                                    {
                                                                        replace: true, state: { id: item.id }
                                                                    }); // 传递状态
                                                            }} />
                                                        <span style={{ marginRight: "15px" }} onClick={() => {
                                                            this.props.navigate('/myPostsInfo',
                                                                {
                                                                    replace: true, state: { id: item.id }
                                                                }); // 传递状态
                                                        }}>{item.yanCount}</span>
                                                        <Image src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                            fit='fill' width={15} height={15} onClick={() => {
                                                                var data = {
                                                                    TableId: item.id,
                                                                    Type: 2,
                                                                    TableType: "Post",
                                                                };
                                                                var model = item.yanList.filter(action =>
                                                                    action.creatorUserId === this.state.userInfo.id);
                                                                if (model.length > 0) {
                                                                    return;
                                                                }
                                                                this.submitForm(data)
                                                            }} />
                                                        <span style={{ marginRight: "15px" }} onClick={() => {
                                                            var data = {
                                                                TableId: item.id,
                                                                Type: 2,
                                                                TableType: "Post",
                                                            };
                                                            var model = item.yanList.filter(action =>
                                                                action.creatorUserId === this.state.userInfo.id);
                                                            if (model.length > 0) {
                                                                return;
                                                            }
                                                            this.submitForm(data)
                                                        }}>{item.zanCount}</span>
                                                    </Space>

                                                </div>
                                            </Grid.Item>
                                        </Grid>
                                    </div>
                                </div>)
                        })
                    }


                    {
                        this.state.page != 0 ?
                            <InfiniteScroll
                                loadMore={this.loadPosts}
                                hasMore={this.state.hasMore}
                                threshold={50}
                                initialLoad={false}
                            >
                                {this.state.loading && (
                                    <div style={{ textAlign: 'center' }}>
                                        <DotLoading color="primary" />
                                        <span style={{ marginLeft: 8 }}>加载中...</span>
                                    </div>
                                )}
                                {!this.state.hasMore && (
                                    <div style={{ marginTop: "8px", width: "100%", marginBottom: "22%" }}>
                                        <Footer label={<>
                                            已经到宇宙的尽头啦{'  '}<SmileOutline color='#0969ff' fontSize={16} />
                                        </>}></Footer>
                                    </div>
                                )}
                            </InfiniteScroll> : null
                    }

                </div>



                {/* <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '28%',
                        '--initial-position-right': '24px',
                        '--edge-distance': '24px',
                        '--size': '40px'
                    }}
                    onClick={() => {
                        this.props.navigate('/driftingDown', { replace: true, state: { from: 'home' } }); // 传递状态
                    }}
                >
                    <GiftOutline fontSize={25} />
                </FloatingBubble> */}

                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '13%',
                        '--initial-position-right': '24px',
                        '--edge-distance': '24px',
                        '--background': '#ffffff00',
                        '--size': '40px'
                    }}
                    onClick={() => {
                        this.props.navigate('/postsAdd', { replace: true }); // 传递状态
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/1/1-15.png"} fit='fill' width={40} height={40} />
                </FloatingBubble>

                <BottomMenu  position="absolute" selectKey="posts" />

            </div>
        )
    }
}

export default withNavigate(Index);